var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("dialogs-base", {
    attrs: { show: _setup.dialog, "max-width": "20%" },
    on: {
      "update:show": function ($event) {
        _setup.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "activator",
        fn: function ({ on, attrs }) {
          return [
            _c(
              "v-text-field",
              _vm._g(
                _vm._b(
                  {
                    attrs: {
                      label: _vm.label,
                      readonly: "",
                      "error-messages": _vm.errorMessages,
                      "hide-details": _vm.errorMessages ? false : true,
                      dense: _vm.dense,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "append",
                          fn: function () {
                            return [
                              _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v("mdi-clock-time-four-outline"),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                    model: {
                      value: _setup.model,
                      callback: function ($$v) {
                        _setup.model = $$v
                      },
                      expression: "model",
                    },
                  },
                  "v-text-field",
                  attrs,
                  false
                ),
                on
              )
            ),
          ]
        },
      },
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "v-time-picker",
              {
                attrs: { "full-width": "", format: "24hr" },
                model: {
                  value: _setup.model,
                  callback: function ($$v) {
                    _setup.model = $$v
                  },
                  expression: "model",
                },
              },
              [
                _c("v-spacer"),
                _c("ButtonsText", {
                  attrs: { label: "Cancelar", color: "error" },
                  on: {
                    click: function ($event) {
                      _setup.dialog = false
                    },
                  },
                }),
                _c("ButtonsText", {
                  attrs: { label: "Confirmar" },
                  on: { click: _setup.closeDialog },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }